module.exports = __webpack_public_path__ + "static/headshot-mike-arpaia-2x.d04fb0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-arpaia-2x.jpg
// module id = 126
// module chunks = 35783957827783 152909308826437